import Api from "../lib/Api";
import { AUTH_FAILURE, AUTH_SUCCESS, SHOW_SNACK, VALIDATE_OTP_FAILURE, VALIDATE_OTP_SUCCESS } from "./types";

export const phoneAuth = body => async dispatch => {
    try {
      const response = await Api.post(body, '/auth');
      if (response.status === 'success') {
        dispatch({
          type: AUTH_SUCCESS,
          payload: {
            mobileNumber: body.mobileNumber,
            isMobileNumberVerified: true
          },
        });
        return true;
      } else {
        dispatch({
          type: SHOW_SNACK,
          payload: {
            open: true,
            error: response.data.error || response.data.message
          }
        })
        dispatch({
          type: AUTH_FAILURE,
          payload: response.data,
        });
        return false;
      }
    } catch (e) {
      dispatch({
        type: SHOW_SNACK,
        payload: {
          open: true,
          error: e.message
        }
      })
      dispatch({
        type: AUTH_FAILURE,
        payload: e.message,
      });
      return false;
    }
  };

  export const validateOtp = body => async dispatch => {
    try {
      const response = await Api.post(body, '/auth/otp');
      if (response.status === 'success') {
        dispatch({
          type: VALIDATE_OTP_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: SHOW_SNACK,
          payload: {
            open: true,
            error: response.data.error || response.data.message
          }
        })
        dispatch({
          type: VALIDATE_OTP_FAILURE,
          payload: response.data,
        });
        return false;
      }
    } catch (e) {
      
      dispatch({
        type: VALIDATE_OTP_FAILURE,
        payload: e.message,
      });
      dispatch({
        type: SHOW_SNACK,
        payload: {
          open: true,
          error: e.message
        }
      })
      return false;
    }
  };